import React, { useEffect, useState } from "react";
import Detail from "./components/Detail";
import SkuTabs from "./components/SkuTabs";
import useApi from "@common/utils/useApi";
import { useNavigate, useParams } from "react-router-dom";
import Loader from "@common/components/Loader";
import apiUrl from "@common/utils/apiURL";
import SeoContainer from "@common/components/SeoContainer";

function CollectionDetail() {
  const { slug } = useParams(); // Get the dynamic id from the route
  const navigate = useNavigate();
  const [collectionGallery, setCollectionGallery] = useState([]);
  const [materialData, setMaterialData] = useState([]);
  const [seoData, setSeoData] = useState(null);
  const getMaterialsURL = apiUrl.collection.getMaterials(slug);

  useEffect(() => {
    if (slug === "" || slug === undefined || slug === null) {
      // commented for time being
      navigate("/collections");
    }
  }, []);

  const { data: response, loading: isLoading, error } = useApi(getMaterialsURL);

  useEffect(() => {
    if (!isLoading && response && response?.CollectionImages) {
      setSeoData({
        pageTitle: `${response?.endUse}-${response?.fabType}`,
        metaDescription: response?.description,
        metaKeywords: response?.tags,
        canonical: window.location.href,
      });
      setCollectionGallery(response.CollectionImages);
      const data = response.MaterialDetails || [];
      data.sort((a, b) => a.serialNo - b.serialNo);
      setMaterialData(data);
      // setMaterialData(response.MaterialDetails);
      localStorage["collection-data"] = JSON.stringify(response);
    }
  }, [isLoading, response]);

  return (
    <>
      {isLoading ? (
        <Loader />
      ) : (
        <>
          <SeoContainer {...seoData} />
          {collectionGallery.length > 0 && (
            <div className="bs-section">
              <div className="bs-section__section-cont">
                <Detail
                  swiperData={collectionGallery}
                  name={response?.name}
                  description={response?.description}
                  brochure_url={response?.brochureUrl}
                />
              </div>
            </div>
          )}
          {materialData.length > 0 && (
            <div className="bs-section">
              <div className="bs-section__section-cont">
                <SkuTabs data={materialData} name={response?.name} />
              </div>
            </div>
          )}
        </>
      )}
    </>
  );
}

export default CollectionDetail;
